import { render, staticRenderFns } from "./khList.vue?vue&type=template&id=3924bcfa&scoped=true&"
import script from "./khList.vue?vue&type=script&lang=js&"
export * from "./khList.vue?vue&type=script&lang=js&"
import style0 from "./khList.vue?vue&type=style&index=0&id=3924bcfa&prod&lang=less&"
import style1 from "./khList.vue?vue&type=style&index=1&id=3924bcfa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3924bcfa",
  null
  
)

export default component.exports